module.exports = __webpack_public_path__ + "img/ResourcesBG.656364db.jpg";